/* Ein Bild aus dem geschützten Speicher laden.
 *
 * Warum ein eigenes Composable: Die ursprüngliche Fassung setzte zuerst ein
 * <img> ohne Quelle in die Seite und trug die Adresse hinterher per
 * DOM-Zugriff nach. Lief das einmal zu früh — etwa bevor die Anmeldung stand —
 * oder wurde die Zeile danach neu gezeichnet, blieb das Bild dauerhaft leer,
 * ohne sichtbaren Fehler. Genau das war bei einem Spieler zu sehen, dessen
 * Bild im Speicher vorhanden war.
 *
 * Hier hängt die Adresse am Zustand: Ändert sich der Pfad oder wird das Bild
 * später erneut gebraucht, lädt es von selbst nach.
 *
 * Fassung: Ohne zweites Argument das Original. Mit 'thumb' oder 'md' die
 * verkleinerte Fassung (domain/photoVariants.js); gibt es sie nicht (alte
 * Fotos), kommt ohne Fehler das Original.
 */

import { ref, watch, toValue } from 'vue';
import { signedImageUrl } from '../supabase/storage.js';

export function useStoredImage(pathSource, variantSource = 'original') {
  const url = ref(null);
  const loading = ref(false);

  watch(
    () => [toValue(pathSource), toValue(variantSource)],
    async ([path, variant]) => {
      if (!path) {
        url.value = null;
        return;
      }
      loading.value = true;
      try {
        url.value = await signedImageUrl(path, variant || 'original');
      } finally {
        loading.value = false;
      }
    },
    { immediate: true }
  );

  return { url, loading };
}
